/**
 * QEVIQ Science — one open details at a time; sync aria-expanded + card state.
 */
(function () {
  function initScience(root) {
    if (!root || root.dataset.qsReady === 'true') return;
    root.dataset.qsReady = 'true';

    var detailsList = Array.prototype.slice.call(root.querySelectorAll('details.qeviq-science-card__details'));

    detailsList.forEach(function (detail) {
      var summary = detail.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      }

      detail.addEventListener('toggle', function () {
        var card = detail.closest('.qeviq-science-card');
        if (summary) {
          summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
        }
        if (card) {
          card.classList.toggle('is-open', detail.open);
        }

        if (!detail.open) return;

        detailsList.forEach(function (other) {
          if (other !== detail && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-qeviq-science]').forEach(initScience);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-qeviq-science]');
    if (root) {
      root.dataset.qsReady = 'false';
      initScience(root);
    }
  });
})();
